import { computed, ComputedRef, ref } from 'vue';
import { LineData } from 'lightweight-charts';
import { useColorMode } from '@vueuse/core';
import { SymbolCandleStickLineChartDataType } from '@core/symbol';

import { CHART_SERIES_COLOR_PALETTE } from '@/modules/symbol';

const selectedTimespan = ref<string>('oneDay');

export default function useSymbolChart(
  chartData: ComputedRef<SymbolCandleStickLineChartDataType | undefined>
) {
  const colorMode = useColorMode();

  const selectedPoint = ref<LineData>();
  const chartPercentage = ref<number>(0);

  const firstPointOfChart = computed(() => {
    return chartData.value ? chartData.value[0] : null;
  });
  const lastPointOfChart = computed(() => {
    return chartData.value ? chartData.value[chartData.value.length - 1] : null;
  });

  const seriesColor = computed(() => {
    if (chartPercentage.value > 0) {
      return CHART_SERIES_COLOR_PALETTE[colorMode.value].GREEN;
    }

    if (chartPercentage.value < 0) {
      return CHART_SERIES_COLOR_PALETTE[colorMode.value].RED;
    }

    return CHART_SERIES_COLOR_PALETTE[colorMode.value].GRAY;
  });

  const handlePercentageChanged = (percentage: number) => {
    chartPercentage.value = percentage;
  };

  const handlePointInfoChanged = (point: LineData) => {
    selectedPoint.value = point;
  };

  return {
    selectedPoint,
    chartPercentage,
    firstPointOfChart,
    lastPointOfChart,
    seriesColor,
    selectedTimespan,

    handlePercentageChanged,
    handlePointInfoChanged,
  };
}
